module.exports = __webpack_public_path__ + "static/img/top_bottom_cao.46df5a18.png";